import { SHOW_MESSAGE, SHOW_ERROR, CLOSE } from './constants';

export const showMessageAction = (message) => ({
  type: SHOW_MESSAGE,
  message,
});

export const showErrorAction = (error) => ({
  type: SHOW_ERROR,
  error,
});

export const closeAction = () => ({
  type: CLOSE,
});
